import { render, staticRenderFns } from "./FamilyMember.vue?vue&type=template&id=117f1310&scoped=true&"
import script from "./FamilyMember.vue?vue&type=script&lang=js&"
export * from "./FamilyMember.vue?vue&type=script&lang=js&"
import style0 from "./../../../../../assets/mobileStyle.css?vue&type=style&index=0&id=117f1310&prod&scoped=true&lang=css&"
import style1 from "./FamilyMember.vue?vue&type=style&index=1&id=117f1310&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117f1310",
  null
  
)

export default component.exports